import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import { VentaListarId } from "../../../../configuracion/apiUrls";
import VerVenta from "./VerVenta"; // Componente anterior adaptado

const DetalleVentaPage = () => {
    // 1. Obtener el id de la venta desde los parámetros de la URL
    const { id } = useParams();
    const navigate = useNavigate();

    const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 2. Función para buscar la venta por ID
    const cargarVenta = useCallback(async () => {
        if (!id) return;
        try {
            setLoading(true);
            setError(null);
            
            // Llamada al endpoint dinámico pasando el ID obtenido por URL
            const response = await AxiosPrivado.get(`${VentaListarId}${id}`);
            
            if (response.data) {
                setVentaSeleccionada(response.data);
            } else {
                setError("No se encontraron datos para la venta solicitada.");
            }
        } catch (err) {
            ErroresPeticion(err);
            setError("Ocurrió un error al cargar la información de la venta.");
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        cargarVenta();
    }, [cargarVenta]);

    // 3. Renderizado condicional según estado de la petición
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center style-loading-container" style={{ minHeight: "400px" }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando detalles de la venta...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-4">
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    <div>{error}</div>
                </div>
                <button className="btn btn-secondary mt-2" onClick={() => navigate(-1)}>
                    <i className="fas fa-arrow-left me-1"></i> Regresar
                </button>
            </div>
        );
    }

    // 4. Pasar la venta seleccionada al componente visual principal
    return (
        <VerVenta 
            ventaSeleccionada={ventaSeleccionada} 
            setVentaSeleccionada={setVentaSeleccionada} 
            recargarVenta={cargarVenta}
        />
    );
};

export default DetalleVentaPage;